import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { RadioCardField, useFormField } from '@frontend/design-system';
import { trackingId } from '../../../../tracking';
import { WizardStep } from './add-step-panel';
import { Step } from './atoms/step';

interface PhoneTreeIntermediateStepProps {
  onNext: (nextStep: WizardStep) => void;
}

export const PhoneTreeIntermediateStep = ({ onNext }: PhoneTreeIntermediateStepProps) => {
  const { t } = useTranslation('phone');

  const cardFieldProps = useFormField({
    type: 'radio',
    required: true,
    value: '',
  });

  const handleContinueClick = () => {
    if (cardFieldProps.value === 'create') {
      onNext('CONFIG');
    } else if (cardFieldProps.value === 'duplicate') {
      onNext('PHONE_TREE_DUPLICATE');
    }
  };

  return (
    <Step
      title={t('Phone Tree')}
      description={t('Select your method of adding a Phone Tree.')}
      primaryButtonLabel={t('Continue')}
      primaryButtonDisabled={!cardFieldProps.value}
      onPrimaryButtonClick={handleContinueClick}
    >
      <RadioCardField
        {...cardFieldProps}
        name='phoneTreeType'
        css={css`
          display: flex;
        `}
      >
        <RadioCardField.Option
          css={css`
            flex: 0 0 304px;
          `}
          value='create'
          title={t('Create New Phone Tree')}
          description={t('Create a new Phone Tree')}
          iconName='add'
          trackingId={trackingId({ context: 'setting', feature: 'call-route', details: 'create-phone-tree-radio' })}
        />
        <RadioCardField.Option
          css={css`
            flex: 0 0 304px;
          `}
          value='duplicate'
          title={t('Duplicate Existing Phone Tree')}
          description={t('Copy and reuse an existing Phone Tree')}
          iconName='copy'
          trackingId={trackingId({ context: 'setting', feature: 'call-route', details: 'duplicate-phone-tree-radio' })}
        />
      </RadioCardField>
    </Step>
  );
};
